import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';

const render = Component => {
ReactDOM.render(
  <>
  <Component />
  </>,
  document.getElementById('root')
);
};

// Do this once
registerServiceWorker();

// Render once
render(NextApp);

